import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FavorietenChangeRequest, GetFavorietenResponse } from '../../model/favoriet/favoriet';

const api = '/api/favorieten';

@Injectable({
  providedIn: 'root'
})
export class FavorietenResource {
  public constructor(private httpClient: HttpClient) {}

  public getFavorieten(): Observable<GetFavorietenResponse> {
    return this.httpClient.get<GetFavorietenResponse>(api);
  }

  public postFavorietenChange(favorietenChangeRequest: FavorietenChangeRequest): Observable<any> {
    return this.httpClient.post<FavorietenChangeRequest>(api, favorietenChangeRequest);
  }

  public deleteFavorietenChange(favorietenChangeRequest: FavorietenChangeRequest): Observable<any> {
    return this.httpClient.request('delete', api, {
      body: favorietenChangeRequest
    });
  }
}
